import type { UserProfileResponse } from '@backrs_ui/grow-ui/src/redux/profile/profile';

export type UserProfile = UserProfileResponse['profile'];

export const FIELD_KEYS_BY_LEVEL = {
  high_school: {
    graduationYear: 'academicHighSchoolExpectedGraduationYear',
    startTerm: 'academicHighSchoolProgramStartTerm',
    startYear: 'academicHighSchoolProgramStartYear',
  },
  post_secondary: {
    graduationYear: 'academicPostSecondaryExpectedGraduationYear',
    startTerm: 'academicPostSecondaryProgramStartTerm',
    startYear: 'academicPostSecondaryProgramStartYear',
  },
} as const;

/**
 * Whether we need to ask the student about their education: either the profile
 * is short a field needed to work out their year, or they have finished the
 * program on file and what comes next is unanswered. Non-students and students
 * not currently enrolled have no year to work out, so neither applies.
 */
export const needsEducationPrompt = (profile: UserProfile, graduated: boolean): boolean => {
  if (profile.publicProfile?.role !== 'student') return false;

  const enrollment = profile.academicEnrollmentTypes;

  if (!enrollment) return true;
  if (enrollment.level === 'none') return false;
  if (graduated) return true;

  const keys = FIELD_KEYS_BY_LEVEL[enrollment.level];

  const needsStartTerm = enrollment.level !== 'high_school' && !profile[keys.startTerm];

  return !profile[keys.graduationYear] || needsStartTerm || !profile[keys.startYear];
};
